/* * 多屏对比 * @module components/contrastComponent/multiContrast * @desc 用于展示对比 * @author sunsi *
@date 2020年8月13日 */
<template>
  <div style="height: 100%">
    <Row style="height: 50%">
      <Col style="height: 100%" span="12">
        <div id="leftMap"></div>
        <div class="treeIcon" @mouseenter.stop="changeTree(1, true)">
          <img src="../../../../static/image/themeservice/layer.png" />
        </div>
        <div v-show="treeC1" class="treeC" @mouseleave.stop="changeTree(1, false)">
          <TreeContrast :mapdata="mapData1"></TreeContrast>
        </div>
        <div
          id="mapType-wrapper1"
          @mouseleave.stop="switchmap(1)"
          @mouseenter.stop="showswitchmap(1)"
        >
          <div id="mapType1">
            <div class="mapTypeCard earth" data-name="earth" @click.stop="showimagelayer(1)">
              <span>影像</span>
            </div>
            <div
              class="mapTypeCard normal choosedType active"
              data-name="normalMap"
              @click.stop="showvector(1)"
            >
              <span>矢量</span>
            </div>
          </div>
        </div>
      </Col>
      <Col style="height: 100%; border-left: 1px solid rgb(178 186 193)" span="12">
        <div id="rightMap"></div>
        <div class="treeIcon" @mouseenter.stop="changeTree(2, true)">
          <img src="../../../../static/image/themeservice/layer.png" />
        </div>
        <div v-show="treeC2" class="treeC" @mouseleave.stop="changeTree(2, false)">
          <TreeContrast :mapdata="mapData2"></TreeContrast>
        </div>
        <div
          id="mapType-wrapper2"
          @mouseleave.stop="switchmap(2)"
          @mouseenter.stop="showswitchmap(2)"
        >
          <div id="mapType2">
            <div class="mapTypeCard earth" data-name="earth" @click.stop="showimagelayer(2)">
              <span>影像</span>
            </div>
            <div
              class="mapTypeCard normal choosedType active"
              data-name="normalMap2"
              @click.stop="showvector(2)"
            >
              <span>矢量</span>
            </div>
          </div>
        </div>
      </Col>
    </Row>
    <Row style="height: 50%; border-top: 1px solid rgb(178 186 193)">
      <Col style="height: 100%" span="12">
        <div id="leftMap2"></div>
        <div class="treeIcon" @mouseenter.stop="changeTree(3, true)">
          <img src="../../../../static/image/themeservice/layer.png" />
        </div>
        <div v-show="treeC3" class="treeC" @mouseleave.stop="changeTree(3, false)">
          <TreeContrast :mapdata="mapData3"></TreeContrast>
        </div>
        <div
          id="mapType-wrapper3"
          @mouseleave.stop="switchmap(3)"
          @mouseenter.stop="showswitchmap(3)"
        >
          <div id="mapType3">
            <div class="mapTypeCard earth" data-name="earth" @click.stop="showimagelayer(3)">
              <span>影像</span>
            </div>
            <div
              class="mapTypeCard normal choosedType active"
              data-name="normalMap"
              @click.stop="showvector(3)"
            >
              <span>矢量</span>
            </div>
          </div>
        </div>
      </Col>
      <Col style="height: 100%; border-left: 1px solid rgb(178 186 193)" span="12">
        <div id="rightMap2"></div>
        <div class="treeIcon" @mouseenter.stop="changeTree(4, true)">
          <img src="../../../../static/image/themeservice/layer.png" />
        </div>
        <div v-show="treeC4" class="treeC" @mouseleave.stop="changeTree(4, false)">
          <TreeContrast :mapdata="mapData4"></TreeContrast>
        </div>
        <div
          id="mapType-wrapper4"
          @mouseleave.stop="switchmap(4)"
          @mouseenter.stop="showswitchmap(4)"
        >
          <div id="mapType4">
            <div class="mapTypeCard earth" data-name="earth" @click.stop="showimagelayer(4)">
              <span>影像</span>
            </div>
            <div
              class="mapTypeCard normal choosedType active"
              data-name="normalMap4"
              @click.stop="showvector(4)"
            >
              <span>矢量</span>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  </div>
</template>
<script>
import multiContrast from './multiContrast';
export default multiContrast;
</script>
<style lang="less" scoped>
#leftMap,
#rightMap {
  height: 100%;
}

.treeC {
  position: absolute;
  width: 32%;
  left: 10px;
  top: 15px;
}

.treeIcon {
  position: absolute;
  left: 10px;
  top: 15px;
  width: 28px;
  height: 25px;
  background-color: #0099fa;
  img {
    width: 100%;
    height: 100%;
  }
}
#mapType-wrapper1,
#mapType-wrapper2,
#mapType-wrapper3,
#mapType-wrapper4 {
  position: absolute;
  width: 88px;
  height: 80px;
  bottom: 0px;
  right: 0;
}
.mapTypeCard {
  height: 60px;
  width: 86px;
  position: absolute;
  border-radius: 2px;
  top: 10px;
  box-sizing: border-box;
  border: 1px solid transparent;
  border: 1px solid rgba(255, 255, 255, 0);
  background: url(../../../../static/maptool/maptype.png) no-repeat 0 0;
  background-size: 86px 240px;
  -webkit-transition-property: right, background-image;
  transition-property: right, background-image;
  -webkit-transition-duration: 0.4s;
  transition-duration: 0.4s;
}
.mapTypeCard .active {
  border: 1px solid #3385ff;
}
.mapTypeCard span {
  position: absolute;
  bottom: 0;
  right: 0;
  display: inline-block;
  padding: 3px 3px 2px 4px;
  font-size: 12px;
  height: 16px;
  line-height: 12px;
  color: #fff;
  border-top-left-radius: 2px;
}
.mapTypeCard.active span {
  background-color: #3385ff;
}
.mapTypeCard:hover span {
  background-color: #3385ff;
}
#mapType1 .normal,
#mapType2 .normal,
#mapType3 .normal,
#mapType4 .normal {
  z-index: 3;
  right: 13px;
  background-image: url(../../../../static/maptool/maptype.png);
  background-position: 0 0;
  border-left: 1px solid rgba(153, 153, 153, 0.6);
}

.expand #mapType1 .mapTypeCard.active,
.expand #mapType2 .mapTypeCard.active,
.expand #mapType3 .mapTypeCard.active,
.expand #mapType4 .mapTypeCard.active {
  border: 1px solid #3385ff;
}

.expand #mapType1,
.expand #mapType2,
.expand #mapType3,
.expand #mapType4 {
  width: 202px;
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.8);
}
.earth {
  right: 15px;
  z-index: 2;
  background-position: 0 -181px;
}

.expand .earth {
  right: 106px;
}
</style>



// WEBPACK FOOTER //
// src/components/contrastComponent/multiContrast/multiContrast.vue